import { render, staticRenderFns } from "./BloodSlideLocation.vue?vue&type=template&id=3c0731ce&scoped=true&"
import script from "./BloodSlideLocation.vue?vue&type=script&lang=js&"
export * from "./BloodSlideLocation.vue?vue&type=script&lang=js&"
import style0 from "./BloodSlideLocation.vue?vue&type=style&index=0&id=3c0731ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0731ce",
  null
  
)

export default component.exports